import { useCallback } from 'react';
import { useSnackbar } from '@ghosts-inc/design-system/hooks';
import Link from '@/components/Link';
import { createWishlist } from '../actions';

type CreateWishlistOptions = {
  showSuccess?: boolean;
  onSuccess?: () => any;
};

type BrandInput = {
  brandName: string;
  budgetInCents?: number | null;
  additionalNotes?: string;
  percentOffMsrpClassificationId?: number | null;
  categories?: string[];
};

export const useCreateWishlist = (
  brandInput: BrandInput,
  { showSuccess = true, onSuccess = undefined }: CreateWishlistOptions,
) => {
  const { showSnackbar, closeSnackbar } = useSnackbar();

  const action = useCallback(async () => {
    const {
      brandName,
      budgetInCents,
      additionalNotes,
      percentOffMsrpClassificationId = null,
      categories = [],
    } = brandInput;

    try {
      await createWishlist({
        searchTerm: brandName,
        budgetInCents,
        additionalNotes,
        percentOffMsrpClassificationId,
        categories,
      });

      if (showSuccess) {
        showSnackbar({
          title: `Wishlist '${brandName}' Created`,
          text: 'Your wishlist request has successfully been created.',
          action: (
            <Link href={`/wishlist/${brandName}`} onClick={closeSnackbar}>
              View All Results
            </Link>
          ),
          severity: 'alertSuccess',
        });
      }
      if (onSuccess) {
        onSuccess();
      }
    } catch {
      showSnackbar({
        title: `Error Creating Wishlist '${brandName}'`,
        text: 'Please try again or refresh your browser',
        severity: 'alertError',
      });
    }
  }, [brandInput, closeSnackbar, onSuccess, showSnackbar, showSuccess]);

  return { createWishlist: action };
};
